import { render } from "./centrechart.vue?vue&type=template&id=97cde106&scoped=true"
import script from "./centrechart.vue?vue&type=script&lang=js"
export * from "./centrechart.vue?vue&type=script&lang=js"

import "./centrechart.vue?vue&type=style&index=0&id=97cde106&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cde106"]])

export default __exports__